var _path, _g, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1125_996",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 0.666656H14.699V18.0389H0.5V0.666656Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1125_996)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95142 1.91666C2.82726 1.91666 1.74976 2.73499 1.74976 4.35082V16.6208C1.74976 16.6992 1.79476 16.7417 1.83226 16.7633C1.86976 16.7867 1.92892 16.8033 1.99726 16.765L7.31559 13.7817C7.50559 13.6758 7.73809 13.675 7.92892 13.7825L13.2014 16.7608C13.2706 16.8008 13.3298 16.7825 13.3673 16.76C13.4048 16.7375 13.4489 16.695 13.4489 16.6167V4.50332C13.4489 3.86416 13.4489 1.91666 10.2506 1.91666H4.95142ZM1.91559 18.0392C1.66976 18.0392 1.42392 17.9733 1.20059 17.8417C0.761423 17.5858 0.499756 17.1283 0.499756 16.6208V4.35082C0.499756 2.00916 2.12226 0.666656 4.95142 0.666656H10.2506C13.0773 0.666656 14.6989 2.06582 14.6989 4.50332V16.6167C14.6989 17.125 14.4373 17.5825 13.9973 17.8383C13.5589 18.095 13.0306 18.1 12.5873 17.85L7.62059 15.0442L2.60809 17.8558C2.39142 17.9775 2.15392 18.0392 1.91559 18.0392Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6164 7.52374H4.51807C4.17307 7.52374 3.89307 7.24374 3.89307 6.89874C3.89307 6.55374 4.17307 6.27374 4.51807 6.27374H10.6164C10.9614 6.27374 11.2414 6.55374 11.2414 6.89874C11.2414 7.24374 10.9614 7.52374 10.6164 7.52374Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.b51026e8.svg";
export { ForwardRef as ReactComponent };